const updateProgramsHistoryArray = (
  programIds: string[],
  programsHistoryArray: string[] | null
): string[] => {
  if (!programsHistoryArray) {
    return [...programIds];
  }

  const newArray = programsHistoryArray.filter((id) => !programIds.includes(id));

  return [...programIds, ...newArray];
};

export default updateProgramsHistoryArray;
